import { Partners } from '@/assets/enums/index.js'
import PartnersMiniLogo from '@/assets/enums/config/PartnersMiniLogo.js'

export type PartnerMenuEntry = {
  id: string
  label: string
  route: { name: string }
  img: { src: string }
}

/**
 * Partner shortcuts (Elys, Enaos): shown in the right bar on desktop and at
 * the bottom of the mobile menu, only for the modules the tenant has.
 */
export function partnerMenuEntries(
  hasModule: (module: string) => boolean
): PartnerMenuEntry[] {
  return [
    {
      id: 'elys',
      label: 'Elys',
      route: { name: 'partners_elys_page_route' },
      img: { src: PartnersMiniLogo[Partners.ELYS] }
    },
    {
      id: 'enaos',
      label: 'Enaos',
      route: { name: 'partners_enaos_page_route' },
      img: { src: PartnersMiniLogo[Partners.ENAOS] }
    }
  ].filter((entry) => hasModule(entry.id))
}
